<template>
  <v-form v-bind="this.$attrs">
    <div>
      <v-row no-gutters>
        <v-col cols="12" md="4">
          <v-select
            :items="exams"
            v-model="exam"
            label="Chọn kỳ kiểm tra"
            item-value="id"
            item-text="name"
            return-object
            outlined
            dense
            clearable
            hide-details
            class="pr-6"
          ></v-select>
        </v-col>

        <v-col cols="2">
          <v-btn
            height="40"
            class="mt-4 mt-md-0"
            style="background-color: white"
            color="#0D47A1"
            @click="onFilterChanged"
            outlined
          >
            Chọn xem
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </v-form>
</template>

<script>
import { get } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

export default {
  props: {},
  data() {
    return {
      exam: '',
      exams: []
    }
  },
  async mounted() {
    await this.getExams()
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    ...mapActions('exam', ['fetchExams']),
    ...mapActions('studentExam', ['fetchStudentExams']),

    onFilterChanged() {
      const params = {
        exam: get(this.exam, 'id', null)
      }
      this.$emit('onFilterChanged', params)
    },
    async getExams() {
      this.$loading.active = true

      const student = get(this.user, 'student._id', null)
      if (student) {
        const studentExams = await this.fetchStudentExams({ student })
        const exams = await this.fetchExams({ status: 'active' })
        const examsWithStudentExams = exams.filter(exam => {
          return studentExams.some(studentExam => studentExam.exam._id === exam._id)
        })

        this.exams = examsWithStudentExams
      }

      this.$loading.active = false
    }
  }
}
</script>

<style scoped>
.invis-btn {
  background-color: transparent !important;
  color: transparent !important;
  border: none !important;
}
</style>
